import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import CardSimple from 'screens/components/basic/CardSimple';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import NoDataMsg from 'library/noData';


const Body = ({ yearlySalesReport, selectedyear }) => {
    return (
        <div id="taxSummaryReport">
            {
                yearlySalesReport.months <= 0 || yearlySalesReport.months.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    //If there's DATA
                    <div>

                        {/* TRANSACTIONS */}

                        {/*<div id="product-list-table">
                    <CardSimple>*/}
                        <div className="row m-0">
                            <div className="text-center list_header">
                                {selectedyear ?
                                    <p> <b>{moment(selectedyear).format('YYYY')}</b>
                                    </p>
                                    : ""}
                            </div>
                        </div>

                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" >
                            <div className="col-lg-12 title_summary">
                                <h3 className="m-0">SUMMARY</h3>
                            </div>{/* row - Date */}

                            <div className="col-lg-12 mb-1">
                                <div className="col-lg-3 col-md-2 col-sm-2 col-xs-4 border-right">
                                    <label>Gross Sales</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(yearlySalesReport.total[0].grossSales)}</h3>
                                </div> {/* Column Orders */}

                                <div className="col-lg-3 col-md-2 col-sm-2 col-xs-4 border-right ">

                                    <label className="sm_label">NetSales</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(yearlySalesReport.total[0].netSales)}</h3>
                                </div> {/* Column Orders */}


                                <div className="col-lg-3 col-md-2 col-sm-2 col-xs-4 border-right ">

                                    <label className="sm_label">Total Tax</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(yearlySalesReport.total[0].taxes)}</h3>
                                </div> {/* Column Orders */}

                                <div className="col-lg-3 col-md-2 col-sm-2 col-xs-4  ">

                                    <label className="sm_label">Discounts</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(yearlySalesReport.total[0].discounts)}</h3>
                                </div> {/* Column Orders */}
                            </div>

                        </div>

                        <div >
                            {
                                yearlySalesReport.months.map((item, index) => {

                                    return (
                                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" key={index}>
                                            <div className="col-lg-12 title_th">
                                                <h3 className="m-0">{moment(item.datetime).format('MMMM , YYYY')}</h3>
                                            </div>{/* row - Date */}

                                            <div className="col-lg-12 mb-1">
                                                <div className="col-lg-3 col-md-2 col-sm-2 col-xs-4 border-right">
                                                    <label>Gross Sales</label>
                                                    <h3 className="m-0 money size_1-3vmax">{getDollarFormat(item.grossSales)}</h3>
                                                </div> {/* Column Orders */}

                                                <div className="col-lg-3 col-md-2 col-sm-2 col-xs-4 border-right ">
                                                    <span className="sm_icon"><EqualizerIcon /></span>
                                                    <label className="sm_label">NetSales</label>
                                                    <h3 className="m-0 grey-text size_1-3vmax">{getDollarFormat(item.netSales)}</h3>
                                                </div> {/* Column Orders */}


                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6 border-right  mt-2_xs">
                                                    <span className="sm_icon"><ShoppingCartIcon /></span>
                                                    <label className="sm_label">Total Tax</label>
                                                    <h3 className="m-0 grey-text size_1-3vmax">{getDollarFormat(item.taxes)}</h3>
                                                </div> {/* Column Orders */}

                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6  mt-2_xs">
                                                    <span className="sm_icon"><MonetizationOnIcon /></span>
                                                    <label className="sm_label">Discounts</label>
                                                    <h3 className="m-0 grey-text size_1-3vmax">{getDollarFormat(item.discounts)}</h3>
                                                </div> {/* Column Orders */}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                        </div>
                        {/*</CardSimple>
                </div>*/}

                    </div>
            }
        </div>
    );
};

export default Body;